import { defineNuxtPlugin } from '#app/nuxt'
import { LazyVuepalAdminToolbar, LazyVuepalLocalTasks, LazyVuepalBreadcrumb, LazyVuepalRemoteVideo, LazyVuepalLink, LazyVuepalTransitionHeight, LazyRokkaImage, LazyNuxtPageDependency, LazyRenderCacheable, LazySpriteSymbol, LazySpriteSymbolInline, LazyBlokkliField, LazyBlokkliEditable, LazyBlokkliProvider, LazyBlokkliItem } from '#components'
const lazyGlobalComponents = [
  ["VuepalAdminToolbar", LazyVuepalAdminToolbar],
["VuepalLocalTasks", LazyVuepalLocalTasks],
["VuepalBreadcrumb", LazyVuepalBreadcrumb],
["VuepalRemoteVideo", LazyVuepalRemoteVideo],
["VuepalLink", LazyVuepalLink],
["VuepalTransitionHeight", LazyVuepalTransitionHeight],
["RokkaImage", LazyRokkaImage],
["NuxtPageDependency", LazyNuxtPageDependency],
["RenderCacheable", LazyRenderCacheable],
["SpriteSymbol", LazySpriteSymbol],
["SpriteSymbolInline", LazySpriteSymbolInline],
["BlokkliField", LazyBlokkliField],
["BlokkliEditable", LazyBlokkliEditable],
["BlokkliProvider", LazyBlokkliProvider],
["BlokkliItem", LazyBlokkliItem],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
